export default __webpack_public_path__ + "static/media/soundcloud.afdaa31a.svg";